export default "__VITE_ASSET__BmZYJ4mm__"